export enum EtatDechargement {
    FINISHED = 'FINISHED',
    NOT_FINISHED = 'NOT_FINISHED',
}